var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShipping(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4993 20.25H6.50068C3.73888 20.25 1.5 22.4325 1.5 25.1248V25.1252C1.5 27.8175 3.73888 30 6.50068 30H29.4993C32.2611 30 34.5 27.8175 34.5 25.1252V25.1248C34.5 22.4325 32.2611 20.25 29.4993 20.25Z",
    fill: "#969696"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.7108 27.75C5.9071 27.7036 5.15458 27.4069 4.60508 26.9198C4.05558 26.4326 3.75 25.7912 3.75 25.125C3.75 24.4588 4.05558 23.8174 4.60508 23.3302C5.15458 22.8431 5.9071 22.5464 6.7108 22.5H29.2892C30.0929 22.5464 30.8454 22.8431 31.3949 23.3302C31.9444 23.8174 32.25 24.4588 32.25 25.125C32.25 25.7912 31.9444 26.4326 31.3949 26.9198C30.8454 27.4069 30.0929 27.7036 29.2892 27.75H6.7108Z",
    fill: "#585757"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9768 26.1328C28.6126 26.1328 29.128 25.6134 29.128 24.9727C29.128 24.3319 28.6126 23.8125 27.9768 23.8125C27.3411 23.8125 26.8257 24.3319 26.8257 24.9727C26.8257 25.6134 27.3411 26.1328 27.9768 26.1328Z",
    fill: "#636799"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9768 26.1328C28.6126 26.1328 29.128 25.6134 29.128 24.9727C29.128 24.3319 28.6126 23.8125 27.9768 23.8125C27.3411 23.8125 26.8257 24.3319 26.8257 24.9727C26.8257 25.6134 27.3411 26.1328 27.9768 26.1328Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3719 26.1328C24.0076 26.1328 24.523 25.6134 24.523 24.9727C24.523 24.3319 24.0076 23.8125 23.3719 23.8125C22.7361 23.8125 22.2207 24.3319 22.2207 24.9727C22.2207 25.6134 22.7361 26.1328 23.3719 26.1328Z",
    fill: "#636799"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3719 26.1328C24.0076 26.1328 24.523 25.6134 24.523 24.9727C24.523 24.3319 24.0076 23.8125 23.3719 23.8125C22.7361 23.8125 22.2207 24.3319 22.2207 24.9727C22.2207 25.6134 22.7361 26.1328 23.3719 26.1328Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9998 26.1328C18.6356 26.1328 19.151 25.6134 19.151 24.9727C19.151 24.3319 18.6356 23.8125 17.9998 23.8125C17.364 23.8125 16.8486 24.3319 16.8486 24.9727C16.8486 25.6134 17.364 26.1328 17.9998 26.1328Z",
    fill: "#636799"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9998 26.1328C18.6356 26.1328 19.151 25.6134 19.151 24.9727C19.151 24.3319 18.6356 23.8125 17.9998 23.8125C17.364 23.8125 16.8486 24.3319 16.8486 24.9727C16.8486 25.6134 17.364 26.1328 17.9998 26.1328Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6277 26.1328C13.2635 26.1328 13.7789 25.6134 13.7789 24.9727C13.7789 24.3319 13.2635 23.8125 12.6277 23.8125C11.992 23.8125 11.4766 24.3319 11.4766 24.9727C11.4766 25.6134 11.992 26.1328 12.6277 26.1328Z",
    fill: "#636799"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6277 26.1328C13.2635 26.1328 13.7789 25.6134 13.7789 24.9727C13.7789 24.3319 13.2635 23.8125 12.6277 23.8125C11.992 23.8125 11.4766 24.3319 11.4766 24.9727C11.4766 25.6134 11.992 26.1328 12.6277 26.1328Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.02323 26.1328C8.659 26.1328 9.1744 25.6134 9.1744 24.9727C9.1744 24.3319 8.659 23.8125 8.02323 23.8125C7.38746 23.8125 6.87207 24.3319 6.87207 24.9727C6.87207 25.6134 7.38746 26.1328 8.02323 26.1328Z",
    fill: "#636799"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.02323 26.1328C8.659 26.1328 9.1744 25.6134 9.1744 24.9727C9.1744 24.3319 8.659 23.8125 8.02323 23.8125C7.38746 23.8125 6.87207 24.3319 6.87207 24.9727C6.87207 25.6134 7.38746 26.1328 8.02323 26.1328Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5829 5.25H10.4171C10.0487 5.25 9.75 5.5594 9.75 5.94107V19.5589C9.75 19.9406 10.0487 20.25 10.4171 20.25H25.5829C25.9513 20.25 26.25 19.9406 26.25 19.5589V5.94107C26.25 5.5594 25.9513 5.25 25.5829 5.25Z",
    fill: "#F2CA52"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5829 5.25H10.4171C10.0487 5.25 9.75 5.5594 9.75 5.94107V19.5589C9.75 19.9406 10.0487 20.25 10.4171 20.25H25.5829C25.9513 20.25 26.25 19.9406 26.25 19.5589V5.94107C26.25 5.5594 25.9513 5.25 25.5829 5.25Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 9.75L18 8.6012L15.75 9.75V5.25H20.25V9.75Z",
    fill: "#737AE6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M21 15.75H25.5V19.5H21V15.75Z",
    fill: "#F2CA52"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M21 15.75H25.5V19.5H21V15.75Z",
    fill: "black",
    fillOpacity: 0.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipping);
export default __webpack_public_path__ + "static/media/shipping.78f088846a2b019d86772696088ca412.svg";
export { ForwardRef as ReactComponent };